import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">
        <p class="poem-block mb-3">
          Вот я и гражданин Европы. И паспорт есть!
          Нетрудно совсем было получить его мне.
          Теперь свершится скоро моя святая месть
          За всё, что белые сделали в моей стране.
        </p>
        
        <p class="poem-block mb-3">
          Зачем нам их аэродромы, банки и сеть дорог,
          Если по этим дорогам они вывозят сырьё,
          И при этом ещё ухитряются не платить налог,
          Разграбляя цинично и жадно государство моё.
        </p>
          
        <p class="poem-block mb-3">
          Их женщины грязно-продажны, доступны всем,
          Они пьют, как свиньи, и жрут свинину – о, грех!
          И хотя я не собираюсь держать гарем,
          Я бы, пусть с отвращеньем, вы…ал бы их всех.
        </p>
      
        <p class="poem-block mb-5">
          Этих свиней не жалко, пускай попадают в ад!
          Истинной веры не зная, они уже обречены.
          И пусть возгорит торжествующий мой джихад
          Над обломками жалкими прежде великой страны!
        </p>
        
      </div>
    `
  )
}

const itemName = {
  rus: 'Песни маленького человека из маленькой Европы, XX век'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;